import { clsx } from 'external/clsx'
import {FC, Card, PropsWithChildren, Link} from 'external/react'
import Icon from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import useParent from 'context/parent-context/hook'

import BasicLayout from './BasicLayout'

const UsersContainer: FC<PropsWithChildren> = props => {
    const {children} = props
	const {params, navigation} = useParent()
    return (
        <BasicLayout>
            <Card.Header className='card--header d-flex'>
                <div className='d-flex flex-column justify-content-center'>
                    <ButtonBack path='/home' />
                </div>
                <div className='ms-2' style={{ fontSize: '31px' }}>
                    <Icon name='faUsers' /> Usuarios
                </div>
                <div style={{ fontSize: '16px' }} className='d-flex flex-grow-1 justify-content-end align-items-center'>
                    <Link to={navigation.users.link({role: 'student'})} style={{ width: '160px' }} className={clsx('language__filter mx-1', {selected: params.role === 'student'})}>
                        <Icon name='faGraduationCap' /> Estudiante
                    </Link>
                    <Link to={navigation.users.link({role: 'tutor'})} style={{ width: '160px' }} className={clsx('language__filter mx-1', {selected: params.role === 'tutor'})}>
                       <Icon name='faPersonChalkboard' /> Tutor
                    </Link>
                </div>
            </Card.Header> 
            {children}
        </BasicLayout>
    )
}

export {UsersContainer as default}